export default class Size{
    static s10:string = "s10";
    static s12:string = "s12";
    static s14:string = "s14";
    static s16:string = "s16";
    static s18:string = "s18";
    static s20:string = "s20";
    static s24:string = "s24";
    static s26:string = "s26";
    static s30:string = "s30";
    static s36:string = "s36";
    static s40:string = "s40";
    static s42:string = "s42";
    static s44:string = "s44";
    static s46:string = "s46";
    static s50:string = "s50";
    static s52:string = "s52";
    static s60:string = "s60";
    static s66:string = "s66";
    static s70:string = "s70";
    static s72:string = "s72";

    static DEFAULT:string = Size.s44;

    static addSizeAndFontSize($cn:string, $size?:string, $fs?:string){
        $cn = this.addSize($cn,$size);
        $cn = this.addFontSize($cn,$fs);     
        return $cn;
    }

    static addSize($cn:string, $size?:string, $default=Size.s44){
        $cn+=" size_"+($size || $default);
        return $cn;
    }
    static addFontSize($cn:string, $fs?:string, $default=Size.s16){
        $cn+=" fs_"+($fs || $default);
        return $cn;
    }

}